import React from "react"
import { useEditing } from "app/regions/hooks/use-editing"

export function Navigation({ properties }) {
  const editing = useEditing()
  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderColor: properties.borderColor,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderCollapse: "separate",
    borderStyle: "solid",
    color: properties.textColor,
    tableLayout: "fixed",
    padding: 16
  }

  return (
    <table>
      <tr>
        <td style={containerStyle} bgcolor={properties.backgroundColor}>
          <table style={{ textAlign: "center" }} align="center">
            <tr>
              {properties.items.map((item, index) => (
                <td key={item.text} style={{ display: "inline-block" }}>
                  <table>
                    <tr>
                      <td style={{ paddingLeft: index === 0 ? 0 : 20 }}>
                        <a
                          href={item.url}
                          onClick={e => (editing ? e.preventDefault() : null)}
                          style={{
                            textDecoration: "none",
                            fontWeight: "bold",
                            lineHeight: "1.5",
                            color: properties.textColor
                          }}
                        >
                          {item.text}
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              ))}
            </tr>
          </table>
        </td>
      </tr>
    </table>
  )
}
